export default __webpack_public_path__ + "static/media/technicalCoaching_icon.6f606864.webp";